<template>
  <div class="spin-stage">
    <a-spin class="loadSpin" tip="Carregando..."/>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.loadSpin{
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 30px 50px;
    margin: 20px 0;
    z-index: 999999;
    position: absolute;
    top: calc(50% - 85px);
    left: calc(50% - 70px);   
}

.spin-stage {
  background: rgba(255, 255, 255, 0.72);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>